var map = {
	"./godwealth_en.png": "84Lz",
	"./godwealth_esp.png": "mNNI",
	"./godwealth_th.png": "dewy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iD0K";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/godwealth_.*\.png$
// module id = iD0K
// module chunks = 1